import React, { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "../context/AppContext";

export default function CopyDisclaimer() {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const { copydisclaimer, showCopy } = useContext(AppContext);

    const closeCopy = () => {
        showCopy(false);
    }

    return (
        <>
            <div className="w-screen absolute h-full mt-60 lg:mt-0 " style={{ zIndex: "100", backgroundColor: "#00000091" }}>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  custom-button-shadow-two rounded p-10 bg-zinc-800 w-11/12 lg:w-3/5">
                    <div className="flex justify-end cursor-pointer" onClick={() => closeCopy()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="size-6 text-blue-300 text-end">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </div>

                    <div className="flex flex-col w-full justify-center lg:justify-left items-center lg:gap-4">
                        <p className="text-white mt-4 text-sm leading-relaxed text-justify">
                            <p className="text-white mt-4 text-justify" dangerouslySetInnerHTML={{ __html: t("_COPY._DISCLAIMER") }}>
                            </p>
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}
